var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 70,
    viewBox: "0 0 119 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115.769,
    cy: 2.69231,
    r: 2.69231,
    fill: "#7E00AA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.769,
    cy: 18.8462,
    r: 2.69231,
    fill: "#7E00AA"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 115.769,
    cy: 35.0002,
    r: 2.69231,
    fill: "#7E00AA"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.6155,
    cy: 2.69231,
    r: 2.69231,
    fill: "#0054E6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.6155,
    cy: 18.8462,
    r: 2.69231,
    fill: "#0054E6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.6155,
    cy: 35.0002,
    r: 2.69231,
    fill: "#0054E6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.6155,
    cy: 51.1539,
    r: 2.69231,
    fill: "#0054E6"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.4616,
    cy: 2.69231,
    r: 2.69231,
    fill: "#0054E6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.4616,
    cy: 18.8462,
    r: 2.69231,
    fill: "#0054E6"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.4616,
    cy: 35.0002,
    r: 2.69231,
    fill: "#0054E6"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.4616,
    cy: 51.1539,
    r: 2.69231,
    fill: "#0054E6"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.4616,
    cy: 67.3078,
    r: 2.69231,
    fill: "#0054E6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.3077,
    cy: 2.69231,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.3077,
    cy: 18.8462,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.3077,
    cy: 35.0002,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.3077,
    cy: 51.1539,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 67.3077,
    cy: 67.3078,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1539,
    cy: 18.8462,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1539,
    cy: 35.0002,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1539,
    cy: 51.1539,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 51.1539,
    cy: 67.3078,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.5
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35.0002,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.2
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 51.1539,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.2
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 67.3078,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.2
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8461,
    cy: 51.1539,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.2
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.8461,
    cy: 67.3078,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.2
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.69228,
    cy: 67.3078,
    r: 2.69231,
    fill: "#0054E6",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotBalance);
export default __webpack_public_path__ + "static/media/dot-balance.e265b09a6fa651bac5a50b0a146080a5.svg";
export { ForwardRef as ReactComponent };